/* ALIZÉ Refonte — JS accueil (reveals, compteurs, carrousel, CTA collant) */
(function(){

  var reduce=window.matchMedia('(prefers-reduced-motion:reduce)').matches;
  var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target);}})},{threshold:.12});
  document.querySelectorAll('.rv').forEach(function(el){io.observe(el);});

  var sb=document.getElementById('statband'),counted=false;
  if(sb){new IntersectionObserver(function(es,ob){es.forEach(function(e){if(e.isIntersecting&&!counted){counted=true;
    sb.querySelectorAll('.v').forEach(function(v){var to=+v.getAttribute('data-to');var u=v.querySelector('.u');var uh=u?u.outerHTML:'';
      if(reduce){v.innerHTML=to+uh;return;}var t0=null;function s(ts){if(!t0)t0=ts;var p=Math.min((ts-t0)/1000,1);v.innerHTML=Math.round((0.5-Math.cos(p*Math.PI)/2)*to)+uh;if(p<1)requestAnimationFrame(s);}requestAnimationFrame(s);});
    ob.disconnect();}});},{threshold:.4}).observe(sb);}

  // sticky mobile cta after hero
  var hero=document.querySelector('.hero'),mcta=document.getElementById('mcta');
  if(hero&&mcta){new IntersectionObserver(function(es){es.forEach(function(e){mcta.classList.toggle('show',!e.isIntersecting);});},{threshold:0}).observe(hero);}

})();
